import React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { LoadingDisplay, ApiRequest, ErrorDisplay, appPaths } from "../../../Common";
import { Company } from "../../../Company/Models/Company";
import { endpoints } from "../../../Company/Constants/endpoints";
import ResponseHandler from "../../../App/ResponseHandler";
import { ResponseResult } from "../../../Common/Models/ResponseResult";
import styles from "../../Styles/UserProfileGeneralInfo.module.scss";

type Props = {
  username: string;
};

type State = {
  hasError: boolean;
  errorCode?: number;
  errorDescription: string;
  isLoading: boolean;
  isLoaded: boolean;
  company?: Company;
};

class UserProfileGeneralInfo extends React.Component<Props & RouteComponentProps, State> {
  constructor(props: Props & RouteComponentProps) {
    super(props);

    this.state = {
      hasError: false,
      errorDescription: "",
      isLoading: true,
      isLoaded: false
    };
  }

  componentDidMount = () => {
    const { username } = this.props;
    const { isLoaded } = this.state;

    if (!isLoaded) {
      ApiRequest.fromPath(endpoints.companies.getByUsername(username))
        .withAuthHeader()
        .get()
        .then((response: Response) => {
          ResponseHandler.handle(
            response,
            (result: ResponseResult<Company>) => {
              this.setState({
                company: result.payload,
                isLoaded: true,
                isLoading: false
              });
            },
            (result: ResponseResult) => {
              this.setState({
                hasError: true,
                errorCode: response.status,
                errorDescription: result.error.message,
                isLoaded: false,
                isLoading: false
              });
            },
            () => {
              this.setState({
                hasError: true,
                errorCode: response.status,
                errorDescription: "An unknown error has occured",
                isLoaded: false,
                isLoading: false
              });
            }
          );
        });
    }
  };

  onCompanyClick = () => {
    if (this.state.company) {
      const { history } = this.props;
      const { company } = this.state;

      history.push(appPaths.company.root.replace(":shortname", company.shortName));
    }
  };

  render() {
    if (this.state.isLoading) {
      return <LoadingDisplay />;
    }

    if (this.state.hasError) {
      return (
        <ErrorDisplay
          errorCode={this.state.errorCode}
          errorDescription={this.state.errorDescription}
          errorResult="Failed to load general information"
        />
      );
    }

    if (!!this.state.company && this.state.isLoaded) {
      return (
        <div>
          <div>
            <span>
              Company:&nbsp;
              <a
                role="button"
                className={styles.link}
                onClick={this.onCompanyClick}
                title={`Click here to see the profile of ${this.state.company.name}`}
              >
                {this.state.company.name}
              </a>
            </span>
          </div>
        </div>
      );
    }

    return null;
  }
}

export default withRouter(UserProfileGeneralInfo);
